import { LabelAsterisk as PrimitiveLabelAsterisk } from '@givebutter/primitives/label';
import { UseFormCombobox } from './UseFormCombobox';
import { GivebutterFormProvider } from 'components/form/GivebutterFormProvider';
import { UseFormCheckboxInput } from 'components/form/UseFormCheckbox';
import { UseFormColorPicker } from 'components/form/UseFormColorPicker';
import { UseFormContainer } from 'components/form/UseFormContainer';
import { UseFormDatePicker } from 'components/form/UseFormDatePicker';
import { UseFormDateTimePicker } from 'components/form/UseFormDateTimePicker';
import {
    Message,
    UseFormError,
    UseFormErrorMessage,
    UseFormErrorValid,
    Valid,
} from 'components/form/UseFormError';
import { UseFormLabel } from 'components/form/UseFormLabel';
import { UseFormRadioGroup } from 'components/form/UseFormRadioGroup';
import { UseFormSingleSelect } from 'components/form/UseFormSingleSelect';
import {
    UseFormSlider,
    UseFormSliderInput,
    UseFormSliderRoot,
    UseFormSliderThumb,
} from 'components/form/UseFormSlider';
import { UseFormSubmitButton } from 'components/form/UseFormSubmitButton';
import { UseFormSwitch } from 'components/form/UseFormSwitch';
import { UseFormTextInputForm, UseFormTextInputRoot } from 'components/form/UseFormTextInput';
import { UseFormTextArea } from 'components/form/UseFormTextarea';
import { UseFormTimePicker } from 'components/form/UseFormTimePicker';
import { useGivebutterForm } from 'components/form/useGivebutterForm';
import { useGivebutterFormContext } from 'components/form/useGivebutterFormContext';

const Provider = GivebutterFormProvider;
const useForm = useGivebutterForm;
const useFormContext = useGivebutterFormContext;
const Container = UseFormContainer;
const Error = UseFormError;
const ErrorMessage = Message;
const ErrorValid = Valid;
const RadioGroup = UseFormRadioGroup;
const Switch = UseFormSwitch;
const TextInputRoot = UseFormTextInputRoot;
const TextInputForm = UseFormTextInputForm;
const Textarea = UseFormTextArea;
const Label = UseFormLabel;
const LabelAsterisk = PrimitiveLabelAsterisk;
const SubmitButton = UseFormSubmitButton;
const SingleSelect = UseFormSingleSelect;
const ColorPicker = UseFormColorPicker;
const Checkbox = UseFormCheckboxInput;
const Combobox = UseFormCombobox;
const Slider = UseFormSlider;
const SliderRoot = UseFormSliderRoot;
const SliderInput = UseFormSliderInput;
const SliderThumb = UseFormSliderThumb;
const DatePicker = UseFormDatePicker;
const DateTimePicker = UseFormDateTimePicker;
const TimePicker = UseFormTimePicker;

export {
    useGivebutterFormContext,
    useGivebutterForm,
    GivebutterFormProvider,
    UseFormContainer,
    UseFormError,
    UseFormErrorMessage,
    UseFormErrorValid,
    UseFormRadioGroup,
    UseFormSwitch,
    UseFormTextInputRoot,
    UseFormTextInputForm,
    UseFormTextArea,
    UseFormLabel,
    UseFormSubmitButton,
    UseFormSingleSelect,
    UseFormColorPicker,
    UseFormCheckboxInput,
    UseFormCombobox,
    UseFormSlider,
    UseFormSliderRoot,
    UseFormSliderInput,
    UseFormSliderThumb,
    UseFormDatePicker,
    UseFormDateTimePicker,
    UseFormTimePicker,
    //
    Provider,
    useForm,
    useFormContext,
    Container,
    Error,
    ErrorMessage,
    ErrorValid,
    RadioGroup,
    TextInputRoot,
    TextInputForm,
    Textarea,
    Switch,
    Label,
    LabelAsterisk,
    SubmitButton,
    SingleSelect,
    ColorPicker,
    Checkbox,
    Combobox,
    Slider,
    SliderRoot,
    SliderInput,
    SliderThumb,
    DatePicker,
    DateTimePicker,
    TimePicker,
};
